import { AppConfig } from '../types';

const decoConfig: Partial<AppConfig> = {
  company: {
    name: 'Deco',
    logo: '/logo512_deco.png',
    slogan: 'Specjaliści w branży elektro-energetycznej',
    about: {
      shortInfo: `Deco to rodzinna firma założona w 1996 roku, specjalizująca się w kompleksowej obsłudze pokryć dachowych. Współpracujemy z czołowymi producentami, takimi jak Braas, Creaton, Velux czy Budmat, oferując wysokiej jakości dachówki, membrany, systemy rynnowe i okna. Dzięki rzetelnej realizacji dachów oraz profesjonalnej obsłudze zdobyliśmy zaufanie Klientów, realizując zarówno standardowe, jak i wymagające projekty. Współpracujemy z niezawodnymi dostawcami i fachowymi wykonawcami, stale się rozwijając. Dziękujemy za zaufanie i zapraszamy do kontaktu!`,
    },
    founded: '1996',
  },
  ui: {
    home: {
      showNewsletterForm: false,
    },
  },
  contact: {
    email: 'kontakt@deco.pl',
    phone: '+48 604 856 094',
    address: {
      street: 'ul. Zaciszańska 20',
      postal: '42-202',
      city: 'Częstochowa',
      region: 'śląskie',
      country: 'Polska',
    },
    googleMaps:
      'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d322779.6799467507!2d19.087668!3d50.799367!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4710b41e028f1a91%3A0x75ae99bd9eec5f21!2sDECO%20-%20CENTRUM%20POKRY%C4%86%20DACHOWYCH!5e0!3m2!1spl!2sus!4v1741987192637!5m2!1spl!2sus',
  },
  social: {
    facebook: 'https://www.facebook.com/decodachy',
    google: 'https://g.co/kgs/MAoU6ph',
  },
  theme: {
    fontFamily: 'Inter, system-ui, sans-serif',
    colors: {
      primary: '#8A1926',
      secondary: '#F6D9E5',
      accent: '#983628',
      background: '#0A0B0A',
      text: '#0A0B0A',
    },
    mainColor: 'red',
  },
};

export default decoConfig;
